import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 70px 0 30px 0;
  overflow: hidden;
  max-width: 100vw;
  width: 100%;
  max-height: calc(100vh - 80px);
  overflow-y: hidden;
  overflow-x: scroll;
  position: absolute;
  height: 100%;
  top: 80px;

  ::-webkit-scrollbar {
      width: 100%; /* Largura da scrollbar */
      background-color: #f1f1f1; /* Cor de fundo da scrollbar */
      height: 12px;
    }

    /* Estilo da parte interna (thumb) que se move */
    ::-webkit-scrollbar-thumb {
      background-color: #888; /* Cor da thumb */
      border-radius: 10px; /* Arredondamento */
      border: 2px solid #f1f1f1; /* Borda ao redor da thumb */
    }

    /* Estilo da scrollbar ao passar o mouse */
    ::-webkit-scrollbar-thumb:hover {
      background-color: #555; /* Cor da thumb ao hover */
    }

    /* Opcional: Estilo dos cantos */
    ::-webkit-scrollbar-corner {
      background-color: #f1f1f1; /* Cor do canto da scrollbar */
    }

  .header{
    position: fixed;
    top: 100px;
    min-width: 600px;
    display: flex;
    z-index: 9999;
    background-color: #FFF;
    justify-content: space-between;
    width: calc(100% - 40px);
    padding-left: 20px;
  }

  .center{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center
  }

  p{
    font-size: 15px;
  }

  button{
    padding: 4px 8px;
    border: none;
    color: #FFF;
    background: #000;
    margin-left: 10px;
    border-radius: 6px;
  }

  h4{
    font-size: 25px;
  }
`;

